$(function(){
	var resizeTimer;
	$(window).on('resize',function(){
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(function(){
			$('.project-header, .personal-inner').each(function(){
				// var y = $(window).height() - $(this).outerHeight();
				var offset = $(this).find('h2').outerHeight() + (0.033 * $(window).width());
				var y = -1 * $(this).outerHeight() + offset;
				if($(window).width() < 1025){
					y = -1 * $(this).outerHeight() + (0.5 * $(window).height());
				}
				$(this).parent().attr('data-offset',offset);
				$(this).css('bottom',y);
			});
		},60);
	}).resize();
})